import * as React from "react";

/**
 * The properties for the Trusted HTML component
 */
export interface ITrustedHtmlComponentProps extends React.HTMLAttributes<HTMLElement> {
  /**
   * The trusted HTML to render
   */
  trustedHtml: TrustedHTML;

  /**
   * The tag name
   */
  tagName?: "div" | "span" | "p";
}

/**
 * Component for displaying HTML that has been sanitized.
 *
 * @param props - the component properties
 * @returns - the JSX markup
 */
export const TrustedHtmlComponent: React.FC<ITrustedHtmlComponentProps> = (props) => {
  // To be treated as JSX, Tag must begin with a capital letter
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { tagName: Tag = "span", trustedHtml, ...otherProps } = props;
  return <Tag {...otherProps} dangerouslySetInnerHTML={{ __html: trustedHtml as unknown as string }}></Tag>;
};
